import React, { useCallback, useEffect, useState } from "react";

import { DeleteOutlined, PhoneFilled } from "@ant-design/icons";
import { Alert, Modal, Popover, Select, Tooltip } from "antd";
import { format, parse } from "date-fns";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { isEmpty } from "lodash";
import { CgCreditCard } from "react-icons/cg";
import { FaRegBuilding, FaSpinner } from "react-icons/fa";
import {
  MdPhoneCallback,
  MdPhone,
  MdInsertComment,
  MdOutlineAddToHomeScreen,
  MdOutlineKeyboardArrowDown,
  MdOutlineDescription,
  MdOutlineEmail,
  MdOutlineLocationOn,
  MdOutlineChat,
  MdInfoOutline,
  MdLockOpen,
  MdLockOutline,
  MdPerson,
  MdEditLocation,
  MdSwapHoriz,
} from "react-icons/md";
import ReactInputMask from "react-input-mask";
import PhoneLinkPlus from "../../../assets/PhoneLinkPlus";
import { usePermissions } from "../../../Context/permissionContext";
import {
  schemaResidencial,
  schemaResidencialAlternativo,
  schemaResidencialComercial,
  schemaResidencialComercialAlternativo,
} from "../../../helpers/schemaEndereco";
import { ufs } from "../../../helpers/ufs";
import { useClient } from "../../../hooks/ClientProvider";
import api from "../../../services/api";
import ModalBiometricRequest from "../../../services/BiometricFace/ModalBiometricRequest";
import { cardProcessorService } from "../../../services/cardProcessorService";
import { capitalize } from "../../../utils/capitalize";
import { customerStatus } from "../../../utils/customerStatus";
import { formatDate } from "../../../utils/formatDate";
import { formatPhone } from "../../../utils/formatPhone";
import { formatCelular } from "../../../utils/formatter";
import { getFaceValidation } from "../../../utils/getPremium";
import { getClientDisplayName } from "../../../utils/socialName";
import { isPhysicalIssuerProduct } from "../../../utils/isPhysicalIssuerProduct";
import {
  notifyError,
  notifyInfo,
  notifySucces,
} from "../../../utils/notifications";
import useCheckPermission from "../../../utils/useCheckPermission";
import ChangeClientProductModal from "./ChangeClientProductModal";
import * as ChangeClientProductStyles from "./ChangeClientProductModal/styles";
import Can from "../../Can";
import Loading from "../../Loading";
import ModalActiveFaturaDigital from "../../ModalActiveFaturaDigital";
import ModalActiveFaturaDigitalSms from "../../ModalActiveFaturaDigitalSms";
import ModalCancelInvoiceSms from "../../ModalCancelInvoiceSms";
import ModalChangeFaturaDigitalSms from "../../ModalChangeFaturaDigitalSms";
import ModalSituacao from "../../ModalSituacao";
import ModalLockAccount from "../ModalLocks/ModalLockAccount";
import ModalUnlockAccount from "../ModalLocks/ModalUnlockAccount";
import * as Style from "../style";
import { AddNewPhone } from "./AddNewPhone";
import DSButton from "../../DSButton";
import ModalEditProfile from "./ModalEditProfile";
import LoadingElevaty from "../../LoadingElevaty";
import { storageService } from "../../../services/storageService";
import { pillCartaoAtivo, pillCartaoBloqueado } from "./style";

const { Option } = Select;

const addressTypes = [
  {
    value: "R",
    label: "Residencial",
  },
  {
    value: "C",
    label: "Comercial",
  },
  {
    value: "L",
    label: "Loja",
  },
];

const normalizeCep = (value) => String(value || "").replace(/\D/g, "");

const getAddressByCep = async (value) => {
  const cep = normalizeCep(value);

  if (cep.length !== 8) {
    return null;
  }

  const response = await api.get("get_cep", { cep });

  return response.data && !response.data.erro ? response.data : null;
};

function TabTitular({ rendaValue }) {
  const { client, updateClient, refreshClientV2, isLoadingClient } =
    useClient();
  const clientId = client?.client?.id;



  const logContactChange = useCallback(
    async (obs) => {
      if (!clientId) return;
      await api.post("timeline", {
        description: "Alteração de contatos",
        obs,
        client_id: clientId,
        contacts_log: true,
      });
      await refreshClientV2();
    },
    [clientId, refreshClientV2]
  );

  const hasPermission = useCheckPermission("edit_personal_data");
  const hasPermissionView = useCheckPermission("view_personal_data");
  const hasPermissionDigital = useCheckPermission("view_digital_invoice");
  const hasPermissionViewNumeroBonificado = useCheckPermission(
    "view_number_subsidized"
  );
  const hasPermissionDeletePhone = useCheckPermission("delete_phoneNumber");
  const hasPermissionToAddOrEditAddress =
    useCheckPermission("edit_add_address");
  const hasPermissionChangeClientProduct = useCheckPermission(
    "permission_change_client_product"
  );
  const isCurrentProductPhysical = isPhysicalIssuerProduct(
    client?.product?.isProdutoDigital
  );
  const showChangeClientProductButton =
    hasPermissionChangeClientProduct && isCurrentProductPhysical;

  const isBlockedUser = client?.client.statusCliente === "A";
  const [modalUnlockAccountOpen, setModalUnlockAccountOpen] = useState(false);
  const [modalLockAccountOpen, setModalLockAccountOpen] = useState(false);

  // ESTADOS DO CONTATOS DO TITULAR:
  const [loading, setLoading] = useState(false);
  const [phones, setPhones] = useState([]);
  const [phone_sms_atual, setPhoneSmsAtual] = useState("");
  const [parameters, setParameters] = useState([]);

  const [auxPhoneSelected, setPhoneSelected] = useState({});
  const [disabledButtonModal, setDisabledButtonModal] = useState(false);
  const [isActivatingSmsPhone, setIsActivatingSmsPhone] = useState(false);

  const [titleFaturaHabitadaSms, setTitleFaturaHabitadaSms] = useState(
    "Habilitado fatura por SMS"
  );
  const [titleFaturaActiveSms, setTitleFaturaActiveSms] = useState(
    "Ativar fatura por SMS"
  );
  const [descriptionFunc, setDescriptionFunc] = useState("");
  const [bodyActiveSMSPhone, setBodyActiveSMSPhone] = useState(false);
  const [modalActiveBiometricsFace, setModalActiveBiometricsFace] =
    useState(false);
  const [modalCancelInvoiceSms, setModalCancelInvoiceSms] = useState(false);
  const [modalActiveInvoiceSms, setModalActiveInvoiceSms] = useState(false);
  const [oldNumberFormat, setOldNumberFormat] = useState("");
  const [modalDeletePhone, setModalDeletePhone] = useState(false);
  const [modalConfirmActiveInvoiceSms, setModalConfirmActiveInvoiceSms] =
    useState(false);
  const [infoAuxClient, setInfoAuxClient] = useState({
    clientId: "",
    telId: "",
    telArea: "",
    telNumero: "",
  });
  const [numberFormat, setNumberFormat] = useState("");

  const [isHiddenComercialAdress, setIsHiddenComercialAdress] = useState(false);
  const [isHiddenAlternativeAdress, setIsHiddenAlternativeAdress] =
    useState(false);

  const { permissions } = usePermissions();

  const [showMoreItems, setShowMoreItems] = useState(false);
  const [isOpenModalPersonalData, setIsOpenModalPersonalData] = useState(false);
  const [isOpenModalPersonalAdress, setIsOpenModalPersonalAdress] =
    useState(false);
  const [isOpenModalPersonalContacts, setIsOpenModalPersonalContacts] =
    useState(false);
  const [isChangeClientProductModalOpen, setIsChangeClientProductModalOpen] =
    useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const [statusModalDesactiveFatura, setStatusModalDesactiveFatura] =
    useState(false);
  const [statusModalActiveFatura, setStatusModalActiveFatura] = useState(false);

  const [loadingEditTitular, setLoadingEditTitular] = useState(false);
  const [useTwoColPersonalData, setUseTwoColPersonalData] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(min-width: 768px)").matches
  );

  const isPch = storageService.getIsPch();

  const statusFaturaDigital = client?.information?.statusFaturaDigital;

  const toggleModalPersonalData = () => {
    setIsOpenModalPersonalData(!isOpenModalPersonalData);
  };

  const toggleModalPersonalAdress = () => {
    setIsOpenModalPersonalAdress(!isOpenModalPersonalAdress);
  };
  const toggleModalPersonalContacts = () => {
    setIsOpenModalPersonalContacts(!isOpenModalPersonalContacts);
  };

  const handleAlternativeAdress = () => {
    setIsHiddenAlternativeAdress(true);
  };
  const handleComercialAdress = () => {
    setIsHiddenComercialAdress(true);
  };

  const handleSubmitFormModal = async (
    currentValues,
    initialValues,
    setErrors
  ) => {
    setLoadingEditTitular(true);

    try {
      const rgHasChanged =
        currentValues?.rg !== initialValues.rg ||
        currentValues?.orgaoEmissor !== initialValues.orgaoEmissor ||
        currentValues?.unidadeFederativaRG !==
        initialValues.unidadeFederativaRG ||
        currentValues?.dataEmissao !== initialValues.dataEmissao;

      if (rgHasChanged) {
        const errors = {};
        if (!currentValues.rg) {
          errors.rg = "Campo obrigatório";
        }
        if (!currentValues.orgaoEmissor) {
          errors.orgaoEmissor = "Campo obrigatório";
        }
        if (!currentValues.unidadeFederativaRG) {
          errors.unidadeFederativaRG = "Campo obrigatório";
        }
        if (!currentValues.dataEmissao) {
          errors.dataEmissao = "Campo obrigatório";
        }

        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          setLoadingEditTitular(false);
          return;
        }
      }

      const payload = {};

      const formatDateToISO = (dateString) => {
        if (!dateString || !dateString.includes("/")) return null;
        const [day, month, year] = dateString.split("/");
        return `${year}-${month}-${day}`;
      };

      if (currentValues.nome !== initialValues.nome) {
        payload.nome = currentValues.nome;
      }

      if (currentValues.nomeSocial !== initialValues.nomeSocial) {
        payload.nomeSocial = currentValues.nomeSocial;
      }

      if (currentValues?.email !== initialValues.email) {
        payload.email = currentValues.email;
      }

      if (currentValues?.birthday !== initialValues.birthday) {
        const formattedBirthday = formatDateToISO(currentValues.birthday);
        if (formattedBirthday) {
          payload.dataNascimento = formattedBirthday;
        }
      }

      if (rgHasChanged) {
        const formattedEmissao = formatDateToISO(currentValues.dataEmissao);
        payload.rg = {
          rg: currentValues.rg,
          orgaoEmissor: currentValues.orgaoEmissor,
          unidadeFederativa: currentValues.unidadeFederativaRG,
          ...(formattedEmissao && { dataEmissao: formattedEmissao }),
        };
      }

      payload.hasChanged = {
        nome: currentValues?.nome !== initialValues.nome,
        nomeSocial: currentValues?.nomeSocial !== initialValues?.nomeSocial,
        email: currentValues?.email !== initialValues.email,
        dataNascimento: currentValues?.birthday !== initialValues.birthday,
        rg: currentValues?.rg !== initialValues.rg,
        orgaoEmissor:
          currentValues?.orgaoEmissor !== initialValues.orgaoEmissor,
        unidadeFederativaRG:
          currentValues?.unidadeFederativaRG !==
          initialValues.unidadeFederativaRG,
        dataEmissao: currentValues?.dataEmissao !== initialValues.dataEmissao,
      };

      if (Object.keys(payload).length === 0) {
        notifyInfo("Nenhuma alteração para salvar.");
        toggleModalPersonalData();
        return;
      }

      await api.patch(`client?client_id=${clientId}&identity=COND`, payload);

      await refreshClientV2();

      notifySucces("Titular atualizado");

      toggleModalPersonalData();
    } catch (err) {
      notifyError("Erro ao atualizar titular", err.message);
    } finally {
      setLoadingEditTitular(false);
    }
  };

  const handleSubmitFormModalAdress = async (values, { setFieldError }) => {
    setDisabledButtonModal(true);

    const snapshotResidencial = client?.client?.endereco_residencial;
    const snapshotAlternativo = client?.client?.endereco_alternativo;
    const snapshotComercial = client?.client?.endereco_comercial;

    const hasStoredAddress = (addr) => {
      if (!addr || typeof addr !== "object") return false;
      return Object.values(addr).some(
        (v) => v != null && String(v).trim() !== ""
      );
    };

    const finalValue = {
      enderecoResidencial: {
        logradouro: values.logradouro,
        complemento: values.complemento,
        numero: values.numero,
        bairro: values.bairro,
        cep: normalizeCep(values.cep),
        uf: values.uf,
        localidade: values.localidade,
      },
    };

    const keysAlternative = Object.keys(values).reduce((acc, key) => {
      if (key.endsWith("_adicional")) {
        acc[key] = values[key];
      }
      return acc;
    }, {});
    const keysAlternativeFiltered = Object.keys(keysAlternative).filter(
      (key) => !key.includes("complemento")
    );
    const isFilledAlternative = keysAlternativeFiltered.every(
      (key) => !!values[key]
    );

    if (isFilledAlternative) {
      finalValue.enderecoAlternativo = {
        logradouro: keysAlternative.logradourotitular_adicional,
        complemento: keysAlternative.complementotitular_adicional,
        numero: keysAlternative.numerotitular_adicional,
        bairro: keysAlternative.bairrotitular_adicional,
        cep: normalizeCep(keysAlternative.ceptitular_adicional),
        localidade: keysAlternative.localidadetitular_adicional,
        uf: keysAlternative.uftitular_adicional,
        tipo: keysAlternative.tipotitular_adicional,
      };
    }

    const keysComercial = Object.keys(values).reduce((acc, key) => {
      if (key.endsWith("_comercial")) {
        acc[key] = values[key];
      }
      return acc;
    }, {});
    const keysComercialFiltered = Object.keys(keysComercial).filter(
      (key) => !key.includes("complemento")
    );
    const isFilledComercial = keysComercialFiltered.every(
      (key) => !!values[key]
    );

    if (isFilledComercial) {
      finalValue.enderecoComercial = {
        bairro: keysComercial.bairrotitular_comercial,
        logradouro: keysComercial.logradourotitular_comercial,
        cep: normalizeCep(keysComercial.ceptitular_comercial),
        complemento: keysComercial.complementotitular_comercial,
        localidade: keysComercial.localidadetitular_comercial,
        numero: keysComercial.numerotitular_comercial,
        uf: keysComercial.uftitular_comercial,
        departamento: keysComercial.departamentotitular_comercial,
        empresa: keysComercial.empresatitular_comercial,
      };
    }

    const cepsToValidate = [
      {
        field: "cep",
        value: finalValue.enderecoResidencial.cep,
        addressType: "residencial",
      },
      ...(finalValue.enderecoComercial
        ? [
            {
              field: "ceptitular_comercial",
              value: finalValue.enderecoComercial.cep,
              addressType: "comercial",
            },
          ]
        : []),
      ...(finalValue.enderecoAlternativo
        ? [
            {
              field: "ceptitular_adicional",
              value: finalValue.enderecoAlternativo.cep,
              addressType: "alternativo",
            },
          ]
        : []),
    ];

    const cepValidationResults = await Promise.all(
      cepsToValidate.map(async (cepToValidate) => {
        try {
          const address = await getAddressByCep(cepToValidate.value);
          return { ...cepToValidate, address };
        } catch (error) {
          return { ...cepToValidate, communicationError: true };
        }
      })
    );
    const invalidCep = cepValidationResults.find(
      ({ address, communicationError }) => !address || communicationError
    );

    if (invalidCep) {
      if (invalidCep.communicationError) {
        setFieldError(
          invalidCep.field,
          "Não foi possível validar o CEP. Tente novamente."
        );
        notifyError("Erro de comunicação ao validar o CEP.");
      } else {
        setFieldError(invalidCep.field, "CEP não encontrado");
        notifyError(
          `O CEP informado no endereço ${invalidCep.addressType} não existe.`
        );
      }

      setDisabledButtonModal(false);
      return;
    }

    if (finalValue) {
      await api
        .patch(`client?client_id=${clientId}&identity=COND`, finalValue)
        .then(async () => {
          updateClient({
            ...client,
            client: {
              ...client.client,
              endereco_residencial: {
                cep: finalValue.enderecoResidencial.cep.replace("-", ""),
                logradouro: finalValue.enderecoResidencial.logradouro,
                bairro: finalValue.enderecoResidencial.bairro,
                localidade: finalValue.enderecoResidencial.localidade,
                uf: finalValue.enderecoResidencial.uf,
                numero: finalValue.enderecoResidencial.numero,
                complemento: finalValue.enderecoResidencial.complemento,
              },
              endereco_alternativo: finalValue?.enderecoAlternativo
                ? {
                  cep: finalValue.enderecoAlternativo.cep.replace("-", ""),
                  logradouro: finalValue.enderecoAlternativo.logradouro,
                  bairro: finalValue.enderecoAlternativo.bairro,
                  localidade: finalValue.enderecoAlternativo.localidade,
                  uf: finalValue.enderecoAlternativo.uf,
                  numero: finalValue.enderecoAlternativo.numero,
                  complemento: finalValue.enderecoAlternativo.complemento,
                  tipo: finalValue.enderecoAlternativo.tipo,
                }
                : undefined,
              endereco_comercial: finalValue?.enderecoComercial
                ? {
                  cep: finalValue.enderecoComercial.cep.replace("-", ""),
                  logradouro: finalValue.enderecoComercial.logradouro,
                  bairro: finalValue.enderecoComercial.bairro,
                  localidade: finalValue.enderecoComercial.localidade,
                  uf: finalValue.enderecoComercial.uf,
                  numero: finalValue.enderecoComercial.numero,
                  complemento: finalValue.enderecoComercial.complemento,
                  tipo: finalValue.enderecoComercial.tipo,
                  empresa: finalValue.enderecoComercial.empresa,
                  departamento: finalValue.enderecoComercial.departamento,
                }
                : undefined,
            },
          });

          const postAddressAudit = async (addressType, before) => {
            await api.post("timeline", {
              client_id: clientId,
              audit_session: "address",
              address_type: addressType,
              address_action: hasStoredAddress(before) ? "edit" : "register",
            });
          };

          await postAddressAudit("residencial", snapshotResidencial);
          if (finalValue.enderecoAlternativo) {
            await postAddressAudit("alternativo", snapshotAlternativo);
          }
          if (finalValue.enderecoComercial) {
            await postAddressAudit("comercial", snapshotComercial);
          }

          await refreshClientV2();
          notifySucces("Endereços atualizados");
        })
        .catch((err) => {
          notifyError("Erro ao atualizar endereços", err.message);
        })
        .finally(() => {
          toggleModalPersonalAdress();
          setDisabledButtonModal(false);
        });
    }
  };

  useEffect(async () => {
    try {
      const response = await cardProcessorService.getParameters();
      setParameters(response);
    } catch (err) {
      console.error("Error to get the parameters", err);
    }
  }, [client]);

  const handleCepBlur = async (
    e,
    setFieldValue,
    setFieldError,
    nameValue
  ) => {
    const cep = normalizeCep(e.target.value);
    let errorFieldPrefix = "";

    if (nameValue === "ceptitular_comercial") {
      errorFieldPrefix = "titular_comercial";
    } else if (nameValue === "ceptitular_adicional") {
      errorFieldPrefix = "titular_adicional";
    }

    const clearAddressFields = () => {
      setFieldValue(`localidade${errorFieldPrefix}`, "");
      setFieldValue(`bairro${errorFieldPrefix}`, "");
      setFieldValue(`logradouro${errorFieldPrefix}`, "");
      setFieldValue(`uf${errorFieldPrefix}`, "");
    };

    if (cep.length !== 8) {
      setFieldError(nameValue, "CEP inválido. O CEP deve conter 8 dígitos.");
      clearAddressFields();
      return;
    }

    setLoadingCep(true);

    try {
      const address = await getAddressByCep(cep);

      if (!address) {
        setFieldError(nameValue, "CEP não encontrado");
        clearAddressFields();
        notifyError("CEP Inválido.");
        return;
      }

      setFieldError(nameValue, undefined);
      setFieldValue(`localidade${errorFieldPrefix}`, address.localidade);
      setFieldValue(`bairro${errorFieldPrefix}`, address.bairro);
      setFieldValue(`logradouro${errorFieldPrefix}`, address.logradouro);
      setFieldValue(`uf${errorFieldPrefix}`, address.uf);
    } catch (error) {
      setFieldError(
        nameValue,
        "Não foi possível validar o CEP. Tente novamente."
      );
      notifyError("Erro de comunicação ao validar o CEP.");
    } finally {
      setLoadingCep(false);
    }
  };

  const closeModalDeletePhone = useCallback(() => {
    setModalDeletePhone(false);
  }, []);

  const openModalDeletePhone = useCallback(() => {
    setModalDeletePhone(true);
  }, []);

  const handleDeletePhone = useCallback(
    (index) => {
      if (phones.length <= 1) {
        notifyError("Não é possível excluir todos os telefones");
        return false;
      }
      const values = [...phones];
      values[index].index = index;

      setPhoneSelected(values[index]);
      openModalDeletePhone();
      return true;
    },
    [openModalDeletePhone, phones]
  );

  const deletePhone = useCallback(async () => {
    setLoading(true);
    if (
      auxPhoneSelected.tipo === "CELULAR" &&
      auxPhoneSelected.isRecebeFaturaSms
    ) {
      await api
        .patch("client_cancel_phone_pdf_sms", {
          identity: "COND",
          client_id: clientId,
          phone_id: auxPhoneSelected.id,
        })
        .catch((error) => {
          setLoading(false);
          closeModalDeletePhone();
          const stringError = error.message;
          // Verifica se a string contém a palavra "detail"
          if (stringError.includes("detail")) {
            const splitArray = stringError.split("detail:");
            const detailText = splitArray[1].split(",")[0].trim();
            return detailText
              ? notifyError(detailText)
              : notifyError("Erro ao deletar telefone");
          }
          const splitArray = stringError.split(",");
          const basicError = splitArray[0].trim();
          return basicError
            ? notifyError(basicError)
            : notifyError("Erro ao deletar telefone");
        });
    }
    api
      .delete("client_phone", {
        identity: "COND",
        client_id: clientId,
        phone_id: auxPhoneSelected.id,
      })
      .then(async () => {
        const values = [...phones];
        values.splice(auxPhoneSelected.index, 1);
        setPhones(values);
        notifySucces("Telefone deletado com sucesso");
        await logContactChange(
          `Exclusão de telefone — tipo: ${auxPhoneSelected.tipo}; número: (${auxPhoneSelected.area}) ${auxPhoneSelected.numero}`
        );

        setLoading(false);
        closeModalDeletePhone();
      })
      .catch((error) => {
        setLoading(false);
        closeModalDeletePhone();
        const stringError = error.message;
        // Verifica se a string contém a palavra "detail"
        if (stringError.includes("detail")) {
          const splitArray = stringError.split("detail:");
          const detailText = splitArray[1].split(",")[0].trim();
          return detailText
            ? notifyError(detailText)
            : notifyError("Erro ao deletar telefone");
        }
        const splitArray = stringError.split(",");
        const basicError = splitArray[0].trim();
        return basicError
          ? notifyError(basicError)
          : notifyError("Erro ao deletar telefone");
      })
      .finally(() => {
        toggleModalPersonalContacts();
      });
  }, [auxPhoneSelected, clientId, closeModalDeletePhone, phones, logContactChange]);

  const onAddNewPhone = useCallback(
    async (obsDetail) => {
      const response = await api.get("client_contacts", { client_id: clientId });

      setPhones(response.data);
      response.data?.map((phone) => {
        if (phone.utilizadoServicoSms === true) {
          const masked_phone_number = formatPhone(phone.area, phone.numero);
          setPhoneSmsAtual({ ...phone, masked_phone_number });
        }
        return phone_sms_atual;
      });
      if (obsDetail) {
        await logContactChange(obsDetail);
      }
    },
    [clientId, logContactChange]
  );

  const handleAfterCancelInvoiceSms = useCallback(async () => {
    const response = await api.get("client_contacts", { client_id: clientId });
    setPhones(response.data);
    response.data.map((phone) => {
      if (phone.utilizadoServicoSms === true) {
        const masked_phone_number = formatPhone(phone.area, phone.numero);
        setPhoneSmsAtual({ ...phone, masked_phone_number });
      }
      return phone_sms_atual;
    });
    await logContactChange(
      `Fatura digital por SMS: cancelamento — ${numberFormat}`
    );
  }, [clientId, numberFormat, logContactChange]);

  const activeSMSPhone = useCallback(
    async (phoneID, phoneArea, phoneNumber, phone_sms) => {
      if (isActivatingSmsPhone) {
        return;
      }

      try {
        setIsActivatingSmsPhone(true);

        await api.patch("client/mark_phone_sms", {
          client_id: clientId,
          phone_id: phoneID,
          phone_area: phoneArea,
          phone_numero: phoneNumber,
          phone_sms_atual: phone_sms,
        });

        const response = await api.get("client_contacts", {
          client_id: clientId,
        });

        setPhones(response.data);

        response.data.map((phone) => {
          if (phone.utilizadoServicoSms === true) {
            const masked_phone_number = formatPhone(phone.area, phone.numero);
            setPhoneSmsAtual({ ...phone, masked_phone_number });
          }
          return phone_sms_atual;
        });

        notifySucces("Alterado celular marcado para receber SMS.");
        await logContactChange(
          `Telefone principal (recebimento SMS): (${phoneArea}) ${phoneNumber}`
        );
      } catch (error) {
        notifyError(error.message);
        throw Error(error.response);
      } finally {
        setIsActivatingSmsPhone(false);
      }
    },
    [client, isActivatingSmsPhone, logContactChange]
  );

  const closeModalChangeInvoiceSms = useCallback(() => {
    setModalConfirmActiveInvoiceSms(false);
  }, []);

  const closeModalActiveBiometricsFace = useCallback(() => {
    setModalActiveBiometricsFace(false);
  }, []);

  const handleActivatePhone = useCallback(
    async (telId) => {
      setLoading(true);
      const phone = phones.find((phoneB) => phoneB.id === telId);

      await api
        .patch("client_mark_phone_bonus", {
          client_id: clientId,
          phone_id: telId,
        })
        .then(async () => {
          await api
            .get("client_contacts", { client_id: clientId })
            .then((response) => {
              setPhones(response.data);
              response.data.map((phone) => {
                if (phone.utilizadoServicoSms === true) {
                  const masked_phone_number = formatPhone(
                    phone.area,
                    phone.numero
                  );
                  setPhoneSmsAtual({ ...phone, masked_phone_number });
                }
                return phone_sms_atual;
              });
            });
          notifySucces("Número bonificado com sucesso");
          setLoading(false);
          await logContactChange(
            `Número bonificado — tipo: ${phone.tipo}; número: (${phone.area}) ${phone.numero}`
          );
        })
        .catch(() => {
          notifyError("Apenas celulares podem receber SMS");
        });
    },
    [client, phones, logContactChange, clientId]
  );

  const closeModalCancelInvoiceSms = useCallback(() => {
    setModalCancelInvoiceSms(false);
  }, []);

  const closeModalActiveInvoiceSms = useCallback(() => {
    setModalActiveInvoiceSms(false);
  }, []);

  const openModalCancelInvoiceSms = useCallback(
    async (clientId, tel) => {
      setInfoAuxClient({ clientId, telId: tel.id });

      const numberFormatted = await formatCelular(tel.numero);
      const numberActive = `(${tel.area}) ${numberFormatted}`;
      await setNumberFormat(numberActive);

      setModalCancelInvoiceSms(true);
    },
    [numberFormat, infoAuxClient]
  );

  const stepValidation = useCallback(
    async (phoneID, phoneArea, phoneNumber, phone_sms, descFunction) => {
      const validationPremium = await getFaceValidation(permissions);
      if (validationPremium) {
        await setDescriptionFunc(descFunction);
        setBodyActiveSMSPhone({ phoneID, phoneArea, phoneNumber, phone_sms });
        setModalActiveBiometricsFace(true);
      } else {
        await activeSMSPhone(phoneID, phoneArea, phoneNumber, phone_sms);
      }
    },
    [getFaceValidation, client, activeSMSPhone]
  );

  const handleInvoiceSms = useCallback(
    async (type, clientId, telId, numberActive) => {
      await api
        .patch("patch_invoice_sms", {
          client_id: clientId,
          celular_id: telId,
          patch_type: type,
          numberActive,
        })
        .then(async () => {
          setModalActiveInvoiceSms(true);
          setTimeout(() => {
            setModalActiveInvoiceSms(false);
          }, 5500);
          const response = await api.get("client_contacts", {
            client_id: clientId,
          });
          setPhones(response.data);
          response.data.map((phone) => {
            if (phone.utilizadoServicoSms === true) {
              const masked_phone_number = formatPhone(
                phone.area,
                phone.numero
              );
              setPhoneSmsAtual({ ...phone, masked_phone_number });
            }
            return phone_sms_atual;
          });
          const obsMsg =
            type === "adesao"
              ? `Fatura digital por SMS: adesão — ${numberActive}`
              : `Fatura digital por SMS: alteração — ${numberActive}`;
          await logContactChange(obsMsg);
        })
        .catch((err) => {
          notifyError(err.message);
          console.error(
            "Erro ao aderir fatura digital pelo celular",
            err.message
          );
        });
    },
    [infoAuxClient, closeModalCancelInvoiceSms, client, logContactChange]
  );

  const activeInvoiceSms = useCallback(
    async (clientId, telId, telArea, telNumero, phoneList) => {
      await setInfoAuxClient({ clientId, telId, telArea, telNumero });

      const numberFormatted = await formatCelular(telNumero);
      const numberActive = `(${telArea}) ${numberFormatted}`;

      await setNumberFormat(numberActive);

      if (phoneList.filter((i) => i.isRecebeFaturaSms === true).length < 1) {
        handleInvoiceSms("adesao", clientId, telId, numberActive);
        closeModalCancelInvoiceSms();
      } else {
        await setOldNumberFormat(
          `(${telArea}) ${formatCelular(
            phoneList.filter((i) => i.isRecebeFaturaSms === true)[0].numero
          )}`
        );
        setModalConfirmActiveInvoiceSms(true).then(() => {
          api
            .get("client_contacts", { client_id: clientId })
            .then((response) => {
              setPhones(response.data);
              response.data.map((phone) => {
                if (phone.utilizadoServicoSms === true) {
                  const masked_phone_number = formatPhone(
                    phone.area,
                    phone.numero
                  );
                  setPhoneSmsAtual({ ...phone, masked_phone_number });
                }
                return phone_sms_atual;
              });
            });
        });
      }
    },
    [setModalActiveInvoiceSms, client]
  );

  const handleCloseModalActiveFaturaDigital = () => {
    setStatusModalActiveFatura(false);
  };

  const handleCloseModalDesactiveFaturaDigital = () => {
    setStatusModalDesactiveFatura(false);
  };

  const handleCancelFaturaDigital = useCallback(async () => {
    await api
      .post("cancel_invoice_digital", {
        client_id: client?.client?.id,
      })
      .then(() => {
        updateClient({
          ...client,
          information: {
            ...client.information,
            statusFaturaDigital: "N",
          },
        });
        setTimeout(() => {
          notifySucces("Fatura digital por e-mail desativada");
          handleCloseModalDesactiveFaturaDigital();
        }, 100);
      });
  }, [client]);

  const handleActiveFaturaDigital = useCallback(async () => {
    await api
      .post("active_invoice_digital", {
        client_id: client?.client?.id,
      })
      .then(() => {
        setStatusModalActiveFatura(true);
        updateClient({
          ...client,
          information: {
            ...client.information,
            statusFaturaDigital: "A",
          },
        });
      });
  }, [client]);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const onChange = () => setUseTwoColPersonalData(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    if (clientId) {
      api.get("client_contacts", { client_id: clientId }).then((response) => {
        setPhones(response.data);

        response.data.map((phone) => {
          if (phone.utilizadoServicoSms === true) {
            const masked_phone_number = formatPhone(phone.area, phone.numero);

            setPhoneSmsAtual({ ...phone, masked_phone_number });
          }
          return phone_sms_atual;
        });
      });
    }

    if (!permissions.includes("add_or_cancel_invoice_by_Sms")) {
      setTitleFaturaHabitadaSms("");
      setTitleFaturaActiveSms("");
    }
  }, []);

  const openModalUnlockAccount = useCallback(async () => {
    setModalUnlockAccountOpen(true);
  });

  const closeModalUnlockAccount = useCallback(
    () => setModalUnlockAccountOpen(false),
    []
  );

  const openModalLockAccount = useCallback(async () => {
    setModalLockAccountOpen(true);
  });

  const closeModalLockAccount = useCallback(
    () => setModalLockAccountOpen(false),
    []
  );

  const handleStateUser = () => {
    if (
      permissions &&
      permissions.includes("unlock_account") &&
      client.client.statusCliente === "B"
    ) {
      openModalUnlockAccount();
    } else if (
      permissions &&
      permissions.includes("lock_account") &&
      client.client.statusCliente === "A"
    ) {
      openModalLockAccount();
    }
  };

  const setValidation = () => {
    let validation;

    const isAlternativeEmpty =
      isEmpty(client?.client?.endereco_alternativo) === false ||
      isHiddenAlternativeAdress === true;
    const isComercialEmpty =
      isEmpty(client?.client?.endereco_comercial) === false ||
      isHiddenComercialAdress === true;

    if (isAlternativeEmpty === false && isComercialEmpty === false) {
      validation = schemaResidencial;
    } else if (isAlternativeEmpty === true && isComercialEmpty === false) {
      validation = schemaResidencialAlternativo;
    } else if (isComercialEmpty === true && isAlternativeEmpty === false) {
      validation = schemaResidencialComercial;
    } else if (isAlternativeEmpty === true && isComercialEmpty === true) {
      validation = schemaResidencialComercialAlternativo;
    }

    return validation;
  };

  const rgValue = client?.client?.rg?.rg || client?.client?.rg;
  const hasValidRg = rgValue && rgValue !== "undefined";

  const overlimitAtivo = !!client?.client?.habilitaOverlimit;
  const pepApi = client?.client?.pep;
  const pepStr = String(pepApi ?? "").toLowerCase();
  const isPepCliente = pepStr === "sim";
  const pepRotulo =
    pepStr === "sim"
      ? "Sim"
      : pepStr === "nao"
        ? "Não"
        : "Não consta";
  const pepPillColors = isPepCliente ? pillCartaoAtivo : pillCartaoBloqueado;
  const overlimitPillColors = overlimitAtivo
    ? pillCartaoAtivo
    : pillCartaoBloqueado;
  const hasPortadorBasicoFlags =
    hasPermissionView &&
    (client?.client?.pep !== undefined ||
      client?.client?.habilitaOverlimit !== undefined);

  return (
    <>
      {isLoadingClient ? (
        <Style.WrapperNewLoading>
          <LoadingElevaty width="50px" height="50px" />
        </Style.WrapperNewLoading>
      ) : (
        <>
          <div className="content-info tab1">
            <div className="content-info-tab1__left">
              <div className="client-id">
                <p>
                  #{client && client.client.id}{" "}
                  {client.client.socialName && `- Nome Social:`}
                </p>
              </div>
              <div className="client-id" data-testid="field-client-registration-date">
                <p data-testid="text-client-registration-date">
                  Data de cadastro do cliente:{" "}
                  {client?.client?.dataCadastro
                    ? formatDate(client.client.dataCadastro)
                    : "Não informado"}
                </p>
              </div>
              <div className="client-name">
                <p>{capitalize(getClientDisplayName(client?.client))}</p>
                {client && client.client.statusCliente && (
                  <span
                    className={`${customerStatus(
                      client.client.statusCliente
                    ).toLocaleLowerCase()} status-new`}
                  >
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={isBlockedUser}
                        onChange={handleStateUser}
                      />
                      <span className="slider" />
                      <span className="knob">
                        {isBlockedUser ? (
                          <MdLockOpen color="#52C41A" />
                        ) : (
                          <MdLockOutline />
                        )}
                      </span>
                    </label>
                    {customerStatus(client.client.statusCliente)}
                  </span>
                )}

                {client.client.statusCliente === "B" &&
                  client.client.ultimoMotivoBloqueioCliente && (
                  <Can permission="permission_view_block_type">
                    <Tooltip title={client.client.ultimoMotivoBloqueioCliente}>
                      <MdInfoOutline />
                    </Tooltip>
                  </Can>
                )}
              </div>

              <div
                className={`client-more-infos ${showMoreItems ? "active" : ""}`}
              >
                {useTwoColPersonalData ? (
                  <div className="client-more-infos__columns">
                    <div className="client-more-infos__col client-more-infos__col--left">
                      {permissions &&
                        permissions.includes("view_income") &&
                        rendaValue && (
                          <p>
                            <span>Renda:</span>{" "}
                            {`${rendaValue.valor.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}`}
                          </p>
                        )}
                      {hasPermissionView &&
                        client.information?.ocupacao?.descricao && (
                          <p>
                            <span>Ocupação:</span>{" "}
                            {client.information.ocupacao.descricao}
                          </p>
                        )}
                      {hasPermissionView && hasValidRg && (
                        <p>
                          <span>RG:</span>{" "}
                          {client?.client?.rg?.rg
                            ? client?.client?.rg?.rg
                            : client?.client?.rg}
                        </p>
                      )}
                      {hasPortadorBasicoFlags && (
                        <Style.PortadorFlagLine>
                          <span>Overlimit:</span>
                          <Style.PortadorPill
                            $border={overlimitPillColors.$border}
                            $color={overlimitPillColors.$color}
                            $bg={overlimitPillColors.$bg}
                          >
                            {overlimitAtivo ? "Ativo" : "Inativo"}
                          </Style.PortadorPill>
                        </Style.PortadorFlagLine>
                      )}
                    </div>
                    <div className="client-more-infos__col client-more-infos__col--right">
                      {hasPermissionView && client.client.birthday && (
                        <p>
                          <span>Nasc.:</span>{" "}
                          {format(
                            parse(
                              client.client.birthday,
                              "yyyy-MM-dd",
                              new Date()
                            ),
                            "dd/MM/yyyy"
                          )}
                        </p>
                      )}
                      {hasPermissionView && client.client.cpf && (
                        <p>
                          <span>CPF:</span>{" "}
                          {client.client.cpf.replace(
                            /(\d{3})(\d{3})(\d{3})(\d{2})/,
                            "$1.$2.$3-$4"
                          )}
                        </p>
                      )}
                      {hasPortadorBasicoFlags && (
                        <Style.PortadorFlagLine>
                          <span>PEP:</span>
                          <Style.PortadorPill
                            $border={pepPillColors.$border}
                            $color={pepPillColors.$color}
                            $bg={pepPillColors.$bg}
                          >
                            {pepRotulo}
                          </Style.PortadorPill>
                        </Style.PortadorFlagLine>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    {permissions &&
                      permissions.includes("view_income") &&
                      rendaValue && (
                        <p>
                          <span>Renda:</span>{" "}
                          {`${rendaValue.valor.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })}`}
                        </p>
                      )}
                    {hasPermissionView && client.client.birthday && (
                      <p>
                        <span>Nasc.:</span>{" "}
                        {format(
                          parse(
                            client.client.birthday,
                            "yyyy-MM-dd",
                            new Date()
                          ),
                          "dd/MM/yyyy"
                        )}
                      </p>
                    )}
                    {hasPermissionView &&
                      client.information?.ocupacao?.descricao && (
                        <p>
                          <span>Ocupação:</span>{" "}
                          {client.information.ocupacao.descricao}
                        </p>
                      )}
                    {hasPermissionView && client.client.cpf && (
                      <p>
                        <span>CPF:</span>{" "}
                        {client.client.cpf.replace(
                          /(\d{3})(\d{3})(\d{3})(\d{2})/,
                          "$1.$2.$3-$4"
                        )}
                      </p>
                    )}
                    {hasPermissionView && hasValidRg && (
                      <p>
                        <span>RG:</span>{" "}
                        {client?.client?.rg?.rg
                          ? client?.client?.rg?.rg
                          : client?.client?.rg}
                      </p>
                    )}
                    {hasPortadorBasicoFlags && (
                      <Style.PortadorFlagLine>
                        <span>PEP:</span>
                        <Style.PortadorPill
                          $border={pepPillColors.$border}
                          $color={pepPillColors.$color}
                          $bg={pepPillColors.$bg}
                        >
                          {pepRotulo}
                        </Style.PortadorPill>
                      </Style.PortadorFlagLine>
                    )}
                    {hasPortadorBasicoFlags && (
                      <Style.PortadorFlagLine>
                        <span>Overlimit:</span>
                        <Style.PortadorPill
                          $border={overlimitPillColors.$border}
                          $color={overlimitPillColors.$color}
                          $bg={overlimitPillColors.$bg}
                        >
                          {overlimitAtivo ? "Ativo" : "Inativo"}
                        </Style.PortadorPill>
                      </Style.PortadorFlagLine>
                    )}
                  </>
                )}
                {client && client.client.socialName && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                      }}
                    >
                      Nome:
                    </span>
                    <p>{capitalize(client.client.name)}</p>
                  </div>
                )}
              </div>
              {client?.product?.desc_prod && (
                <div
                  className="product-info-section"
                  data-testid="section-client-product"
                >
                  <span>Produto: </span>
                  <ChangeClientProductStyles.ProductRow>
                    <div className="product" data-testid="field-current-product">
                      <CgCreditCard width={16} />
                      <h3 data-testid="text-current-product-name">
                        {client?.product?.desc_prod}
                      </h3>
                    </div>

                    {showChangeClientProductButton && (
                      <Tooltip title="Trocar Produto">
                        <ChangeClientProductStyles.ChangeProductButton
                          type="button"
                          aria-label="Trocar Produto"
                          data-testid="btn-open-change-client-product"
                          onClick={() => setIsChangeClientProductModalOpen(true)}
                        >
                          <MdSwapHoriz size={18} />
                          Trocar Produto
                        </ChangeClientProductStyles.ChangeProductButton>
                      </Tooltip>
                    )}
                  </ChangeClientProductStyles.ProductRow>
                </div>
              )}
              {!!client?.client?.diasAtrasoTotal &&
                (client?.client?.estaEmAtraso === true ||
                  client?.client?.estanoCobranca === "S") && (
                  <Alert
                    type="warning"
                    message={`Dias em atraso: ${client?.client?.diasAtrasoTotal} dias`}
                    showIcon
                    className="days-late-section"
                  />
                )}
              <div className="client-separator show none">
                <hr />
              </div>
            </div>

            <div className="content-info-tab1__right">
              <div className="tab-right__item-left">
                {hasPermissionView && (
                  <div className="client-phone">
                    <div className="principal-phone">
                      <p>
                        <MdPhoneCallback />{" "}
                        {phone_sms_atual?.masked_phone_number}
                      </p>
                    </div>

                    <div className="list-icons-phone">
                      {hasPermissionViewNumeroBonificado && (
                        <div className="list-icons-phone__icon">
                          {phone_sms_atual?.utilizadoTaxaBonificada ? (
                            <Tooltip title="Número Bonificado">
                              <button type="button" aria-label="icon">
                                <MdOutlineAddToHomeScreen color="#52c41a" />
                              </button>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Ativar Número bonificado">
                              <button
                                type="button"
                                aria-label="icon"
                                onClick={() =>
                                  handleActivatePhone(phone_sms_atual?.id)
                                }
                              >
                                <MdOutlineAddToHomeScreen />
                              </button>
                            </Tooltip>
                          )}
                        </div>
                      )}

                      {phone_sms_atual?.utilizadoServicoSms ? (
                        <Tooltip title="Número ativo">
                          <div className="list-icons-phone__icon">
                            <button type="button" aria-label="icon">
                              <MdPhone color="#52c41a" />
                            </button>
                          </div>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Ativar Recebimento de sms">
                          <div className="list-icons-phone__icon">
                            <button
                              type="button"
                              aria-label="icon"
                              disabled={isActivatingSmsPhone}
                            >
                              <MdPhone
                                onClick={
                                  permissions &&
                                  permissions.includes("main_contact") &&
                                  (() =>
                                    stepValidation(
                                      phone_sms_atual?.id,
                                      phone_sms_atual?.area,
                                      phone_sms_atual?.numero,
                                      phone_sms_atual.masked_phone_number,
                                      "Alterar telefone principal"
                                    ))
                                }
                              />
                            </button>
                          </div>
                        </Tooltip>
                      )}

                      {phone_sms_atual?.tipo === "CELULAR" &&
                        parameters.habilitarEnvioSms === true &&
                        (phone_sms_atual?.isRecebeFaturaSms ? (
                          <div className="list-icons-phone__icon">
                            <Tooltip title={titleFaturaHabitadaSms}>
                              <button type="button" aria-label="icon">
                                <MdInsertComment
                                  color="#52c41a"
                                  onClick={
                                    permissions &&
                                    permissions.includes(
                                      "add_or_cancel_invoice_by_Sms"
                                    ) &&
                                    (() =>
                                      openModalCancelInvoiceSms(
                                        clientId,
                                        phone_sms_atual
                                      ))
                                  }
                                />
                              </button>
                            </Tooltip>
                          </div>
                        ) : (
                          <Tooltip title={titleFaturaActiveSms}>
                            <div className="list-icons-phone__icon">
                              <button type="button" aria-label="icon">
                                <MdInsertComment
                                  onClick={
                                    permissions &&
                                    permissions.includes(
                                      "add_or_cancel_invoice_by_Sms"
                                    ) &&
                                    (() =>
                                      activeInvoiceSms(
                                        clientId,
                                        phone_sms_atual?.id,
                                        phone_sms_atual?.area,
                                        phone_sms_atual?.numero,
                                        phones
                                      ))
                                  }
                                />
                              </button>
                            </div>
                          </Tooltip>
                        ))}
                    </div>
                  </div>
                )}

                <div className="client-separator show">
                  <hr />
                </div>

                <div
                  className={`client-info-email ${showMoreItems ? "active" : ""
                    }`}
                >
                  {hasPermissionView && (
                    <>
                      <div className="client-info-email__address">
                        <span>
                          <MdOutlineEmail />
                        </span>
                        <p> {client?.client?.email}</p>
                      </div>
                      {!!statusFaturaDigital && (
                        <div className="client-info-email__btn">
                          <Popover
                            placement="bottom"
                            content={
                              statusFaturaDigital === "A"
                                ? "Habilitado fatura digital"
                                : statusFaturaDigital === "P"
                                  ? "Cliente com adesão pendente"
                                  : "Ativar fatura digital"
                            }
                          >
                            <button
                              className={statusFaturaDigital}
                              type="button"
                              aria-label="btn-email"
                              onClick={() => {
                                if (
                                  statusFaturaDigital === "A" &&
                                  hasPermissionDigital
                                ) {
                                  setStatusModalDesactiveFatura(true);
                                }

                                if (
                                  statusFaturaDigital === "N" &&
                                  hasPermissionDigital
                                ) {
                                  handleActiveFaturaDigital();
                                }
                              }}
                            >
                              <MdOutlineDescription />
                            </button>
                          </Popover>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {hasPermissionView && client?.information?.lojaDeCadastro && (
                  <>
                    <div className="client-separator show">
                      <hr />
                    </div>

                    <div
                      className={`client-info-email ${showMoreItems ? "active" : ""
                        }`}
                    >
                      <div className="client-info-email__address">
                        <span className="business">
                          <FaRegBuilding />
                        </span>
                        <p> {client?.information?.lojaDeCadastro}</p>
                      </div>
                    </div>
                  </>
                )}

                <div
                  className={`client-separator none  ${showMoreItems ? "show" : ""
                    }`}
                >
                  <hr />
                </div>
              </div>

              <div className="tab-right__item-right">
                <div
                  className={`client-edit-options  ${showMoreItems ? "active" : ""
                    }`}
                >
                  <Can permission="view_personal_data">
                    <Tooltip title="Editar Dados Pessoais">
                      <DSButton
                        isIconAfter={false}
                        icon={<MdPerson />}
                        buttonText="Dados Pessoais"
                        onClick={toggleModalPersonalData}
                        buttonType="primary"
                      />
                    </Tooltip>
                    <Tooltip title="Editar Contatos" placement="right">
                      <DSButton
                        isIconAfter={false}
                        icon={<MdPhone />}
                        buttonText="Contatos"
                        onClick={toggleModalPersonalContacts}
                        buttonType="primary"
                      />
                    </Tooltip>
                    <Tooltip title="Editar Endereços" placement="right">
                      <DSButton
                        isIconAfter={false}
                        icon={<MdEditLocation />}
                        buttonText="Endereços"
                        onClick={toggleModalPersonalAdress}
                        buttonType="primary"
                      />
                    </Tooltip>
                  </Can>
                </div>
              </div>
            </div>
            <div className="btn-show-more">
              <button
                type="button"
                aria-label="btn-show-more"
                onClick={() => setShowMoreItems(!showMoreItems)}
              >
                <p>
                  <MdOutlineKeyboardArrowDown
                    className={showMoreItems && "active"}
                  />{" "}
                  {showMoreItems ? "Mostrar menos" : "Mostrar mais"}
                </p>
              </button>
            </div>
          </div>
        </>
      )
      }

      <ChangeClientProductModal
        open={isChangeClientProductModalOpen}
        onClose={() => setIsChangeClientProductModalOpen(false)}
        onSuccess={() => setIsChangeClientProductModalOpen(false)}
      />

      <ModalEditProfile
        client={client}
        disabledButtonModal={disabledButtonModal}
        handleSubmitFormModal={handleSubmitFormModal}
        hasPermissionToEditPersonalData={hasPermission}
        hasPermissionView={hasPermissionView}
        isOpenModalPersonalData={isOpenModalPersonalData}
        toggleModalPersonalData={toggleModalPersonalData}
        ufs={ufs}
        loading={loadingEditTitular}
      />

      <Modal
        title="Editar endereços"
        visible={isOpenModalPersonalAdress}
        onCancel={toggleModalPersonalAdress}
        width={600}
      >
        <Style.ModalTitular>
          <Formik
            initialValues={{
              cep: client?.client?.endereco_residencial?.cep,
              logradouro: client?.client?.endereco_residencial?.logradouro,
              bairro: client?.client?.endereco_residencial?.bairro,
              localidade: client?.client?.endereco_residencial?.localidade,
              uf: client?.client?.endereco_residencial?.uf,
              numero: client?.client?.endereco_residencial?.numero,
              complemento: client?.client?.endereco_residencial?.complemento,
              cnpj: client?.client?.endereco_comercial?.cnpj,
              ceptitular_comercial: client?.client?.endereco_comercial?.cep,
              departamento: client?.client?.endereco_comercial?.departamento,
              logradourotitular_comercial:
                client?.client?.endereco_comercial?.logradouro,
              bairrotitular_comercial:
                client?.client?.endereco_comercial?.bairro,
              localidadetitular_comercial:
                client?.client?.endereco_comercial?.localidade,
              uftitular_comercial: client?.client?.endereco_comercial?.uf,
              numerotitular_comercial:
                client?.client?.endereco_comercial?.numero,
              complementotitular_comercial:
                client?.client?.endereco_comercial?.complemento,
              empresatitular_comercial:
                client?.client?.endereco_comercial?.empresa,
              departamentotitular_comercial:
                client?.client?.endereco_comercial?.departamento,
              ceptitular_adicional: client?.client?.endereco_alternativo?.cep,
              logradourotitular_adicional:
                client?.client?.endereco_alternativo?.logradouro,
              bairrotitular_adicional:
                client?.client?.endereco_alternativo?.bairro,
              localidadetitular_adicional:
                client?.client?.endereco_alternativo?.localidade,
              uftitular_adicional: client?.client?.endereco_alternativo?.uf,
              numerotitular_adicional:
                client?.client?.endereco_alternativo?.numero,
              complementotitular_adicional:
                client?.client?.endereco_alternativo?.complemento,
              tipotitular_adicional: client?.client?.endereco_alternativo?.tipo,
            }}
            validationSchema={setValidation}
            onSubmit={handleSubmitFormModalAdress}
            enableReinitialize
          >
            {({ resetForm, setFieldValue, setFieldError }) => (
              <Form>
                {hasPermissionView && (
                  <div className="modal-titular__left">
                    <div
                      className="modal-titular__title"
                      style={{ marginTop: "5px" }}
                    >
                      <p>
                        <MdOutlineLocationOn /> Endereço residencial do titular
                      </p>
                    </div>

                    <div className="item-input">
                      <label htmlFor="cep">CEP</label>
                      <Field name="cep">
                        {({ field, meta }) => (
                          <ReactInputMask
                            label="cep"
                            placeholder="CEP"
                            mask="99999-999"
                            maskChar=""
                            className={
                              meta.touched && meta.error ? "error-id" : null
                            }
                            disabled={!hasPermissionToAddOrEditAddress}
                            {...field}
                            autoComplete="off"
                            onChange={(e) => field.onChange(e)}
                            onBlur={(e) => {
                              field.onBlur(e);
                              handleCepBlur(
                                e,
                                setFieldValue,
                                setFieldError,
                                "cep"
                              );
                            }}
                          />
                        )}
                      </Field>

                      <div className={`loading ${loadingCep ? "active" : ""}`}>
                        <FaSpinner color="#5188F4" />
                      </div>
                      <ErrorMessage
                        name="cep"
                        className="error"
                        component="span"
                      />
                    </div>

                    <div className="item-input">
                      <label htmlFor="logradouro">Logradouro</label>
                      <Field name="logradouro">
                        {({ field, meta }) => (
                          <input
                            className={
                              meta.touched && meta.error ? "error-id" : null
                            }
                            type="text"
                            placeholder="Logradouro"
                            disabled={!hasPermissionToAddOrEditAddress}
                            {...field}
                            autoComplete="off"
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="logradouro"
                        className="error"
                        component="span"
                      />
                    </div>

                    <div className="item-input">
                      <label htmlFor="bairro">Bairro</label>
                      <Field name="bairro">
                        {({ field, meta }) => (
                          <input
                            className={
                              meta.touched && meta.error ? "error-id" : null
                            }
                            type="text"
                            placeholder="Bairro"
                            disabled={!hasPermissionToAddOrEditAddress}
                            {...field}
                            autoComplete="off"
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="bairro"
                        className="error"
                        component="span"
                      />
                    </div>

                    <div className="grid-2">
                      <div className="item-input">
                        <label htmlFor="localidade">Cidade</label>
                        <Field name="localidade">
                          {({ field, meta }) => (
                            <input
                              className={
                                meta.touched && meta.error ? "error-id" : null
                              }
                              type="text"
                              placeholder="Cidade"
                              disabled={!hasPermissionToAddOrEditAddress}
                              {...field}
                              autoComplete="off"
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="localidade"
                          className="error"
                          component="span"
                        />
                      </div>

                      <div className="item-input">
                        <label htmlFor="uf">UF</label>
                        <Field name="uf">
                          {({ field, meta }) => (
                            <Select
                              {...field}
                              value={field?.value || undefined}
                              disabled={!hasPermissionToAddOrEditAddress}
                              onChange={(value) => setFieldValue("uf", value)}
                              className={
                                meta.touched && meta.error ? "error-id" : null
                              }
                              showSearch
                              placeholder="UF"
                            >
                              {ufs.map((value) => (
                                <Option
                                  key={`tab-titular-uf-${value}`}
                                  value={value}
                                >
                                  {value}
                                </Option>
                              ))}
                            </Select>
                          )}
                        </Field>
                        <ErrorMessage
                          name="uf"
                          className="error"
                          component="span"
                        />
                      </div>
                    </div>

                    <div className="grid-2">
                      <div className="item-input">
                        <label htmlFor="numero">Número</label>
                        <Field name="numero">
                          {({ field, meta }) => (
                            <input
                              className={
                                meta.touched && meta.error ? "error-id" : null
                              }
                              type="text"
                              placeholder="Número"
                              disabled={!hasPermissionToAddOrEditAddress}
                              {...field}
                              autoComplete="off"
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="numero"
                          className="error"
                          component="span"
                        />
                      </div>

                      <div className="item-input">
                        <label htmlFor="complemento">Complemento</label>
                        <Field name="complemento">
                          {({ field, meta }) => (
                            <input
                              className={
                                meta.touched && meta.error ? "error-id" : null
                              }
                              type="text"
                              placeholder="Complemento"
                              disabled={!hasPermissionToAddOrEditAddress}
                              {...field}
                              autoComplete="off"
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="complemento"
                          className="error"
                          component="span"
                        />
                      </div>
                    </div>

                    {isEmpty(client?.client?.endereco_comercial) === false ||
                      isHiddenComercialAdress === true ? (
                      <>
                        <div
                          className="modal-titular__title"
                          style={{ marginTop: "32px" }}
                        >
                          <p>
                            <MdOutlineLocationOn /> Endereço comercial do
                            titular
                          </p>
                        </div>
                        <div className="grid-2">
                          <div className="item-input">
                            <label htmlFor="empresatitular_comercial">
                              Empresa
                            </label>
                            <Field name="empresatitular_comercial">
                              {({ field, meta }) => (
                                <ReactInputMask
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  label="empresa"
                                  placeholder="Empresa"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="empresatitular_comercial"
                              className="error"
                              component="span"
                            />
                          </div>

                          <div className="item-input">
                            <label htmlFor="departamentotitular_comercial">
                              Departamento
                            </label>
                            <Field name="departamentotitular_comercial">
                              {({ field, meta }) => (
                                <ReactInputMask
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  label="departamento"
                                  placeholder="Departamento"
                                  maskChar=""
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="departamentotitular_comercial"
                              className="error"
                              component="span"
                            />
                          </div>
                        </div>
                        <div className="item-input">
                          <label htmlFor="ceptitular_comercial">CEP</label>
                          <Field name="ceptitular_comercial">
                            {({ field, meta }) => (
                              <ReactInputMask
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                label="cep"
                                placeholder="CEP"
                                mask="99999-999"
                                maskChar=""
                                disabled={!hasPermissionToAddOrEditAddress}
                                {...field}
                                autoComplete="off"
                                onChange={(e) => field.onChange(e)}
                                onBlur={(e) => {
                                  field.onBlur(e);
                                  handleCepBlur(
                                    e,
                                    setFieldValue,
                                    setFieldError,
                                    "ceptitular_comercial"
                                  );
                                }}
                              />
                            )}
                          </Field>

                          <div
                            className={`loading ${loadingCep ? "active" : ""}`}
                          >
                            <FaSpinner color="#5188F4" />
                          </div>
                          <ErrorMessage
                            name="ceptitular_comercial"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="item-input">
                          <label htmlFor="logradourotitular_comercial">
                            Logradouro
                          </label>
                          <Field name="logradourotitular_comercial">
                            {({ field, meta }) => (
                              <input
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                type="text"
                                placeholder="Logradouro"
                                disabled={!hasPermissionToAddOrEditAddress}
                                {...field}
                                autoComplete="off"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="logradourotitular_comercial"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="item-input">
                          <label htmlFor="bairrotitular_comercial">
                            Bairro
                          </label>
                          <Field name="bairrotitular_comercial">
                            {({ field, meta }) => (
                              <input
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                type="text"
                                placeholder="Bairro"
                                disabled={!hasPermissionToAddOrEditAddress}
                                {...field}
                                autoComplete="off"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="bairrotitular_comercial"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="grid-2">
                          <div className="item-input">
                            <label htmlFor="localidadetitular_comercial">
                              Cidade
                            </label>
                            <Field name="localidadetitular_comercial">
                              {({ field, meta }) => (
                                <input
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  type="text"
                                  placeholder="Cidade"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="localidadetitular_comercial"
                              className="error"
                              component="span"
                            />
                          </div>

                          <div className="item-input">
                            <label htmlFor="uftitular_comercial">UF</label>
                            <Field name="uftitular_comercial">
                              {({ field, meta }) => (
                                <Select
                                  defaultValue=""
                                  {...field}
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  value={field?.value || undefined}
                                  onChange={(value) =>
                                    setFieldValue("uftitular_comercial", value)
                                  }
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  showSearch
                                  placeholder="UF"
                                >
                                  {ufs.map((value) => (
                                    <Option
                                      key={`tab-titular-uf-titular-adicional-${value}`}
                                      value={value}
                                    >
                                      {value}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            </Field>
                            <ErrorMessage
                              name="uftitular_comercial"
                              className="error"
                              component="span"
                            />
                          </div>
                        </div>

                        <div className="grid-2">
                          <div className="item-input">
                            <label htmlFor="numerotitular_comercial">
                              Número
                            </label>
                            <Field name="numerotitular_comercial">
                              {({ field, meta }) => (
                                <input
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  type="text"
                                  placeholder="Número"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="numerotitular_comercial"
                              className="error"
                              component="span"
                            />
                          </div>

                          <div className="item-input">
                            <label htmlFor="complementotitular_comercial">
                              Complemento
                            </label>
                            <Field name="complementotitular_comercial">
                              {({ field, meta }) => (
                                <input
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  type="text"
                                  placeholder="Complemento"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="complementotitular_comercial"
                              className="error"
                              component="span"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Style.BtnAddress>
                          <Style.AddButton
                            type="button"
                            onClick={handleComercialAdress}
                            disabled={!hasPermissionToAddOrEditAddress}
                          >
                            {hasPermissionToAddOrEditAddress
                              ? "Adicionar um endereço comercial"
                              : "Usuário sem permissão para adicionar endereços"}
                          </Style.AddButton>

                          <div className="bg-btn" />
                        </Style.BtnAddress>
                        <p style={{ textAlign: "center" }}>
                          <strong>Sem endereço comercial</strong>
                        </p>
                      </>
                    )}

                    {isEmpty(client?.client?.endereco_alternativo) === false ||
                      isHiddenAlternativeAdress === true ? (
                      <>
                        <div
                          className="modal-titular__title"
                          style={{ marginTop: "32px" }}
                        >
                          <p>
                            <MdOutlineLocationOn /> Endereço alternativo do
                            titular
                          </p>
                        </div>
                        <div className="item-input">
                          <label htmlFor="ceptitular_adicional">CEP</label>
                          <Field name="ceptitular_adicional">
                            {({ field, meta }) => (
                              <ReactInputMask
                                label="cep"
                                placeholder="CEP"
                                mask="99999-999"
                                maskChar=""
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                disabled={!hasPermissionToAddOrEditAddress}
                                {...field}
                                autoComplete="off"
                                onChange={(e) => field.onChange(e)}
                                onBlur={(e) => {
                                  field.onBlur(e);
                                  handleCepBlur(
                                    e,
                                    setFieldValue,
                                    setFieldError,
                                    "ceptitular_adicional"
                                  );
                                }}
                              />
                            )}
                          </Field>

                          <div
                            className={`loading ${loadingCep ? "active" : ""}`}
                          >
                            <FaSpinner color="#5188F4" />
                          </div>
                          <ErrorMessage
                            name="ceptitular_adicional"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="item-input">
                          <label htmlFor="logradourotitular_adicional">
                            Logradouro
                          </label>
                          <Field name="logradourotitular_adicional">
                            {({ field, meta }) => (
                              <input
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                type="text"
                                placeholder="Logradouro"
                                disabled={!hasPermissionToAddOrEditAddress}
                                {...field}
                                autoComplete="off"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="logradourotitular_adicional"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="item-input">
                          <label htmlFor="bairrotitular_adicional">
                            Bairro
                          </label>
                          <Field name="bairrotitular_adicional">
                            {({ field, meta }) => (
                              <input
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                type="text"
                                placeholder="Bairro"
                                disabled={!hasPermissionToAddOrEditAddress}
                                {...field}
                                autoComplete="off"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="bairrotitular_adicional"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="grid-2">
                          <div className="item-input">
                            <label htmlFor="localidadetitular_adicional">
                              Cidade
                            </label>
                            <Field name="localidadetitular_adicional">
                              {({ field, meta }) => (
                                <input
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  type="text"
                                  placeholder="Cidade"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="localidadetitular_adicional"
                              className="error"
                              component="span"
                            />
                          </div>

                          <div className="item-input">
                            <label htmlFor="uftitular_adicional">UF</label>
                            <Field name="uftitular_adicional">
                              {({ field, meta }) => (
                                <Select
                                  defaultValue=""
                                  {...field}
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  value={field?.value || undefined}
                                  onChange={(value) =>
                                    setFieldValue("uftitular_adicional", value)
                                  }
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  showSearch
                                  placeholder="UF"
                                >
                                  {ufs.map((value) => (
                                    <Option
                                      key={`tab-titular-uf-titular-adicional-${value}`}
                                      value={value}
                                    >
                                      {value}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            </Field>
                            <ErrorMessage
                              name="uftitular_adicional"
                              className="error"
                              component="span"
                            />
                          </div>
                        </div>

                        <div className="grid-2">
                          <div className="item-input">
                            <label htmlFor="numerotitular_adicional">
                              Número
                            </label>
                            <Field name="numerotitular_adicional">
                              {({ field, meta }) => (
                                <input
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  type="text"
                                  placeholder="Número"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="numerotitular_adicional"
                              className="error"
                              component="span"
                            />
                          </div>

                          <div className="item-input">
                            <label htmlFor="complementotitular_adicional">
                              Complemento
                            </label>
                            <Field name="complementotitular_adicional">
                              {({ field, meta }) => (
                                <input
                                  className={
                                    meta.touched && meta.error
                                      ? "error-id"
                                      : null
                                  }
                                  type="text"
                                  placeholder="Complemento"
                                  disabled={!hasPermissionToAddOrEditAddress}
                                  {...field}
                                  autoComplete="off"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="complementotitular_adicional"
                              className="error"
                              component="span"
                            />
                          </div>
                        </div>
                        <div className="item-input">
                          <label htmlFor="tipotitular_adicional">Tipo</label>
                          <Field name="tipotitular_adicional">
                            {({ field, meta }) => (
                              <Select
                                {...field}
                                value={field?.value || undefined}
                                disabled={!hasPermissionToAddOrEditAddress}
                                onChange={(value) =>
                                  setFieldValue("tipotitular_adicional", value)
                                }
                                className={
                                  meta.touched && meta.error ? "error-id" : null
                                }
                                showSearch
                                placeholder="Tipo do endereço"
                              >
                                {addressTypes.map(({ label, value }) => (
                                  <Option
                                    key={`tab-titular-tipo-endereco-${value}`}
                                    value={value}
                                  >
                                    {label}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          </Field>
                          <ErrorMessage
                            name="tipotitular_adicional"
                            className="error"
                            component="span"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <Style.BtnAddress>
                          <Style.AddButton
                            type="button"
                            onClick={handleAlternativeAdress}
                            disabled={!hasPermissionToAddOrEditAddress}
                          >
                            {hasPermissionToAddOrEditAddress
                              ? "Adicionar um endereço alternativo"
                              : "Usuário sem permissão para adicionar endereços"}
                          </Style.AddButton>

                          <div className="bg-btn" />
                        </Style.BtnAddress>
                        <p style={{ textAlign: "center" }}>
                          <strong>Sem endereço alternativo</strong>
                        </p>
                      </>
                    )}
                  </div>
                )}
                <Can permission="edit_add_address">
                  <div className="footer-modal">
                    <button
                      type="button"
                      onClick={() => {
                        toggleModalPersonalAdress();
                        resetForm();
                      }}
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="submit"
                      disabled={disabledButtonModal}
                    >
                      Salvar
                    </button>
                  </div>
                </Can>
              </Form>
            )}
          </Formik>
        </Style.ModalTitular>
      </Modal>

      <Modal
        title="Editar Contatos"
        visible={isOpenModalPersonalContacts}
        onCancel={toggleModalPersonalContacts}
        width={600}
        destroyOnClose
      >
        <Style.ModalTitular>
          <div className="modal-titular__left">
            <div className="modal-titular__content">
              {hasPermissionView && (
                <div className="modal-titular__right">
                  <div className="modal-titular__title">
                    <p>
                      <MdPhoneCallback /> Contatos do titular
                    </p>
                  </div>
                  {phones.map((tel, index) => (
                    <Style.Inputs key={JSON.stringify(tel)}>
                      <Style.InputsContent>
                        <Style.InputsLabel>
                          <span>{tel.tipo}</span>

                          {/* <Tooltip
                          title={`Recebe fatura: ${tel.utilizadoFaturaDigital ? 'sim' : 'não'
                            }. Recebe pacote sms: ${tel.utilizadoServicoSms ? 'sim' : 'não'
                            }`}
                        >
                          <InfoCircleOutlined />
                        </Tooltip> */}
                        </Style.InputsLabel>
                        <Style.InputsRow>
                          <ReactInputMask
                            id={`focus-${index}`}
                            disabled={!!tel.id}
                            name="telephone"
                            value={tel.area + tel.numero}
                            mask={
                              tel.tipo === "CELULAR" ||
                                tel.tipo === "REFERENCIA" ||
                                tel.tipo === "COMERCIAL"
                                ? "(99) 99999-9999"
                                : "(99) 9999-9999"
                            }
                          />
                        </Style.InputsRow>
                      </Style.InputsContent>
                      <Style.TelephoneTypeContent>
                        {loading && tel.id === "" ? (
                          <Loading />
                        ) : (
                          <Style.TelephoneTrash>
                            {/* O cenário sem id nunca deve acontecer, mas a verificação está mantida por segurança */}
                            {tel.id ? (
                              <>
                                {" "}
                                {(isPch === false ||
                                  isPch === "" ||
                                  isPch === null) && (
                                    <DeleteOutlined
                                      title="Deletar"
                                      // eslint-disable-next-line consistent-return
                                      onClick={() => {
                                        if (hasPermissionDeletePhone === true)
                                          return handleDeletePhone(index);
                                      }}
                                      className={
                                        hasPermissionDeletePhone === false
                                          ? "off"
                                          : ""
                                      }
                                    />
                                  )}
                                {hasPermissionViewNumeroBonificado && (
                                  <>
                                    {tel.utilizadoTaxaBonificada ? (
                                      <Tooltip title="Número Bonificado">
                                        <PhoneLinkPlus className="on" />
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title="Ativar Número bonificado">
                                        <PhoneLinkPlus
                                          className="off"
                                          onClick={() =>
                                            handleActivatePhone(tel.id)
                                          }
                                        />
                                      </Tooltip>
                                    )}
                                  </>
                                )}
                                {tel.utilizadoServicoSms ? (
                                  <Tooltip title="Número ativo">
                                    <PhoneFilled
                                      className={`on ${isActivatingSmsPhone ? "activating" : ""
                                        }`}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Ativar Recebimento de sms">
                                    <PhoneFilled
                                      className={`off ${isActivatingSmsPhone ? "activating" : ""
                                        }`}
                                      onClick={
                                        permissions &&
                                        permissions.includes("main_contact") &&
                                        (() =>
                                          stepValidation(
                                            tel.id,
                                            tel.area,
                                            tel.numero,
                                            phone_sms_atual.masked_phone_number,
                                            "Alterar telefone principal"
                                          ))
                                      }
                                    />
                                  </Tooltip>
                                )}
                                {tel.tipo === "CELULAR" &&
                                  parameters.habilitarEnvioSms === true &&
                                  (tel.isRecebeFaturaSms ? (
                                    <Tooltip title={titleFaturaHabitadaSms}>
                                      <MdOutlineChat
                                        className="on"
                                        onClick={
                                          permissions &&
                                          permissions.includes(
                                            "add_or_cancel_invoice_by_Sms"
                                          ) &&
                                          (() =>
                                            openModalCancelInvoiceSms(
                                              clientId,
                                              tel
                                            ))
                                        }
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title={titleFaturaActiveSms}>
                                      <MdOutlineChat
                                        className="off"
                                        onClick={
                                          permissions &&
                                          permissions.includes(
                                            "add_or_cancel_invoice_by_Sms"
                                          ) &&
                                          (() =>
                                            activeInvoiceSms(
                                              clientId,
                                              tel?.id,
                                              tel?.area,
                                              tel?.numero,
                                              phones
                                            ))
                                        }
                                      />
                                    </Tooltip>
                                  ))}
                              </>
                            ) : (
                              <></>
                            )}
                          </Style.TelephoneTrash>
                        )}
                      </Style.TelephoneTypeContent>
                    </Style.Inputs>
                  ))}

                  <AddNewPhone
                    onAddNewPhone={onAddNewPhone}
                    envioSmsHabilitado={parameters.habilitarEnvioSms === true}
                  />
                </div>
              )}
            </div>
          </div>
        </Style.ModalTitular>
      </Modal>

      <Modal
        title="Deletar telefone"
        visible={modalDeletePhone}
        onCancel={closeModalDeletePhone}
        destroyOnClose
      >
        <Style.TelephoneContainerDelete>
          <span>Tem certeza que deseja deletar o telefone?</span>
          <Style.TelephoneDelete>
            ({auxPhoneSelected.area}) {auxPhoneSelected.numero}
          </Style.TelephoneDelete>
          <Style.ModalButtonContainerTitular>
            {loading ? (
              <Loading />
            ) : (
              <>
                <button type="button" onClick={closeModalDeletePhone}>
                  Cancelar
                </button>
                <button type="button" onClick={() => deletePhone()}>
                  Confirmar
                </button>
              </>
            )}
          </Style.ModalButtonContainerTitular>
        </Style.TelephoneContainerDelete>
      </Modal>

      <ModalBiometricRequest
        statusOpen={modalActiveBiometricsFace}
        closeModal={closeModalActiveBiometricsFace}
        cpfClient={client.client.cpf}
        clientId={client.client.id}
        bodyActiveFunction={bodyActiveSMSPhone}
        activefunction={activeSMSPhone}
        requiredBy={descriptionFunc}
      />
      <ModalActiveFaturaDigitalSms
        statusOpen={modalActiveInvoiceSms}
        closeModal={() => closeModalActiveInvoiceSms()}
      />

      <ModalChangeFaturaDigitalSms
        statusOpen={modalConfirmActiveInvoiceSms}
        closeModal={() => closeModalChangeInvoiceSms()}
        clientInfo={infoAuxClient}
        numberFormat={numberFormat}
        oldNumberFormat={oldNumberFormat}
        phones={phones}
        handleInvoiceSms={handleInvoiceSms}
      />
      <ModalCancelInvoiceSms
        statusOpen={modalCancelInvoiceSms}
        closeModal={() => closeModalCancelInvoiceSms()}
        clientInfo={infoAuxClient}
        numberFormat={numberFormat}
        onSuccess={handleAfterCancelInvoiceSms}
      />

      <ModalLockAccount
        open={modalLockAccountOpen}
        closeModal={closeModalLockAccount}
        clientID={client.client.id}
      />
      <ModalUnlockAccount
        open={modalUnlockAccountOpen}
        closeModal={closeModalUnlockAccount}
        clientID={client.client.id}
      />
      <ModalSituacao
        statusOpen={statusModalDesactiveFatura}
        closeModal={() => handleCloseModalDesactiveFaturaDigital()}
        handleSituacao={() => handleCancelFaturaDigital()}
      />

      <ModalActiveFaturaDigital
        statusOpen={statusModalActiveFatura}
        closeModal={() => handleCloseModalActiveFaturaDigital()}
      />
    </>
  );
}

export default TabTitular;
